import { createSlice } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    permissionisLoading : false,
    permissionCLoading : false,
    totalCurrency: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    menuisCLoading:false,
    permissionCstatus:"",
    permissionCMessage:"",
    permissiondetails:[],
    singlepermissiondetails:[],
    permissionismloading:false,
    permissionmstatus:"",
    permissionmmessage:"",
    permissiondmessage:"",
    menues: {},
    menudstatus:"",
    menudmessage:"",
    error:"",
    permissiondstatus:"",
    combinedpermissiondetails:[],
    combinedrolepermissiondetails:[]
    
    
};


const rolepermissionSlice = createSlice({
    name: "rolePermissionList",
    initialState,
    reducers:{
        getPermissionPending: (state) => {
            state.permissionisLoading = true;
        },
        getPermissionSuccess: (state, { payload }) => {
            state.permissionisLoading = false;
           // state.menu = payload;
            state.permissiondetails = payload;
           // state.user="slice userData";
            state.error = '';
        
        },
        getPermissionFail: (state, { payload }) => {
            state.permissionisLoading = false;
            state.error = payload;
        },
        createPermissionPending:(state,action) => {
            state.permissionCLoading=true;
        },
        createPermissionSuccess:(state,{payload}) => {
            state.permissionCLoading=false;
            state.permissionCstatus="success";
            state.permissionCMessage=payload;
        },
        createPermissionFail:(state,{payload}) => {
            state.permissionCLoading=false;
            state.permissionCstatus="fail";
            //console.log('slice '+payload);
            state.permissionCMessage=payload;
        },
        getSPermissionPending: (state) => {
            state.permissionisLoading = true;
        },
        getSPermissionSuccess: (state, { payload }) => {
            state.permissionisLoading = false;
            state.singlepermissiondetails=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSPermissionFail: (state, { payload }) => {
            state.permissionisLoading = false;
            state.error = payload;
        },
        modifyPermissionPending:(state,action) => {
            state.permissionismloading=true;
            state.permissionmstatus="";
        },
        modifyPermissionSuccess:(state,{payload}) => {
            state.permissionismloading=false;
            state.permissionmstatus="success";
           
            state.permissionmmessage="Permission Successfully Updated";
        },
        modifyPermissionFail:(state,{payload}) => {
            state.permissionismloading=false;
            state.permissionmstatus="fail";
           // console.log('slice '+payload);
            state.permissionmmessage=payload;
        },
        deletePermissionPending:(state,action) => {
            state.permissionisLoading=true;
            state.permissiondstatus="";
        },
        deletePermissionSuccess:(state,{payload}) => {
            state.permissionisLoading=false;
            state.permissiondstatus="success";
            state.permissiondmessage="Permission Successfully Deleted";
        },
        deletePermissionFail:(state,{payload}) => {
            state.permissionisLoading=false;
            state.permissiondstatus="fail";
           // console.log('slice '+payload);
            state.permissiondmessage=payload;
        },
        getCPermissionPending: (state) => {
            state.permissionisLoading = true;
        },
        getCPermissionSuccess: (state, { payload }) => {
            state.permissionisLoading = false;
            state.combinedpermissiondetails=payload;
           // state.user="slice userData";
            state.error = '';
            console.log(payload);
        },
        getCPermissionFail: (state, { payload }) => {
            state.permissionisLoading = false;
            state.error = payload;
        },
        getSRPermissionPending: (state) => {
            state.permissionisLoading = true;
        },
        getSRPermissionSuccess: (state, { payload }) => {
            state.permissionisLoading = false;
            state.combinedrolepermissiondetails=payload;
           // state.user="slice userData";
            state.error = '';
            console.log(payload);
        },
        getSRPermissionFail: (state, { payload }) => {
            state.permissionisLoading = false;
            state.error = payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = rolepermissionSlice;

export const { getPermissionPending, getPermissionSuccess, getPermissionFail,
    getSPermissionPending,getSPermissionSuccess,getSPermissionFail,
    createPermissionPending,createPermissionSuccess,createPermissionFail,
    modifyPermissionPending,modifyPermissionSuccess,modifyPermissionFail,
    deletePermissionPending,deletePermissionSuccess,deletePermissionFail,
    getCPermissionPending,getCPermissionSuccess,getCPermissionFail,
    getSRPermissionPending,getSRPermissionSuccess,getSRPermissionFail} = actions;

export default reducer;
